import React, { Component } from 'react'
import { Dispatch } from 'react-redux'
import * as validation from '~/helper/constant/validation'
import { getEmployeeCategory, editEmployeeCategory } from '~/services/api'
import { API_SUCCESS, API_FAILURE } from '~/helper/constant/api_status'
import * as Status from '~/helper/constant/status'
import * as route from '~/helper/constant/route'
import { toastMessage } from '~/helper/function/util'
import moment from 'moment'
import $ from 'jquery'
import { redirect } from '~/helper/function/util'

type Props = {
    token: String,
    dispatch: Dispatch<any>,
}

type State = {
    name: String,
    code: String,
    errors: Object,
    loading: Boolean,
    loading_text: String,
}

export class AbstractEmployeeCategoryEditComponent extends Component<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = {
            loading: false,
            name: '',
            code: '',
            errors: {
                name: null,
            },
        }
        this._handleChange = this._handleChange.bind(this)
        this._onSave = this._onSave.bind(this)
        this.loadCategory = this.loadCategory.bind(this)
    }

    componentDidMount() {
        this.loadCategory()
    }

    _handleChange(key, data) {
        this.setState({ [key]: data })
    }

    loadCategory() {
        this._handleChange('loading_text', 'Loading')
        this._handleChange('loading', true)
        getEmployeeCategory(this.props.match.params.id, this.props.token).then((response) => {
            this._handleChange('loading', false)
            if (response.code == API_SUCCESS) {
                this._handleChange('name', response.data.user_category.name)
                this._handleChange('code', response.data.user_category.code)
            }
        })
    }

    _onSave(e) {
        e.preventDefault()
        const errors = validation.required(Object.keys(this.state.errors), this.state)
        this.setState({ errors })
        const validate = Object.keys(errors).filter((item) => errors[item] != null)
        if (validate.length == 0) {
            const data = {
                name: this.state.name,
                code: this.state.code,
            }
            this._handleChange('loading_text', 'Saving')
            this._handleChange('loading', true)
            editEmployeeCategory(this.props.match.params.id, data, this.props.token).then((response) => {
                if (response.code == API_SUCCESS) {
                    toastMessage('success', response.message)
                    redirect(route.admin.user.employee.category.view, this.props.history)
                } else {
                    toastMessage('error', response.message)
                    if (response.data) {
                        if ('errors' in response.data) {
                            this.setState({ errors: response.data.errors })
                        }
                    }
                }
                this._handleChange('loading', false)
            })
        }
    }
}

export function mapStateToProps(state: Object) {
    return {
        token: state.token,
    }
}
